// JobDescriptionAddEditModal.jsx
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  FormFeedback,
} from "reactstrap";

const defaultDriverInfo = {
  user: "",
  note: "",
  date: ""
};

const InprogressAddEditModal = ({
  inProgressAddEditModalOpen,
  setInProgressAddEditModalOpen,
  editableData = null, // pass existing item to edit
  onSubmit, // function(finalData) => void
}) => {
  const [description, setDescription] = useState("");
  const [driverInfo, setDriverInfo] = useState({ ...defaultDriverInfo });

  // errors for validation (fieldName -> message)
  const [errors, setErrors] = useState({});

  // Load editable data on open or reset on add
  useEffect(() => {
    if (editableData) {
      setDescription(editableData.description || "");
      setDriverInfo((prev) => ({ ...defaultDriverInfo, ...editableData.driverInfo }));
    } else {
      setDescription("");
      setDriverInfo({ ...defaultDriverInfo });
    }
    setErrors({});
  }, [editableData, inProgressAddEditModalOpen]);

  const closeModal = () => {
    setInProgressAddEditModalOpen(false);
  };

  const handleDriverInfoChange = (field, value) => {
    setDriverInfo((prev) => ({ ...prev, [field]: value }));
    // clear error on change
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const copy = { ...prev };
      delete copy[field];
      return copy;
    });
  };

  // Validate only the required fields requested by you
  const validateForm = () => {
    const newErrors = {};

    if (!driverInfo.note || !driverInfo.note.toString().trim()) {
      newErrors.note = "note is required.";
    }

    if (!driverInfo.user || !driverInfo.user.toString().trim()) {
      newErrors.user = "Minimum required user is required.";
    }

    if (!driverInfo.routeType || !driverInfo.routeType.toString().trim()) {
      newErrors.routeType = "Route type is required.";
    }

    if (!driverInfo.driverPay || !driverInfo.driverPay.toString().trim()) {
      newErrors.driverPay = "Driver pay is required.";
    }

    if (!driverInfo.payday || !driverInfo.payday.toString().trim()) {
      newErrors.payday = "Payday is required.";
    }

    // optional: ensure questionTemplates (if provided) is a non-negative integer
    if (
      driverInfo.questionTemplates !== "" &&
      driverInfo.questionTemplates !== null &&
      !Number.isInteger(Number(driverInfo.questionTemplates))
    ) {
      newErrors.questionTemplates = "Question templates must be an integer.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    // if (!validateForm()) {
    //   return;
    // }

    const finalData = {
      description,
      driverInfo,
    };

    if (typeof onSubmit === "function") {
      onSubmit(finalData);
    } else {
      console.log("Submitted data:", finalData);
    }

    closeModal();
  };

  return (
    <Modal
      isOpen={inProgressAddEditModalOpen}
      toggle={closeModal}
      backdrop="static"
      size="md"
      className="modal-full-height"
      centered
    >
      <ModalBody className="modal-height-fixed overflow-y-auto">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="fw-bold m-0">
            {editableData ? "EDIT SCHEDULE" : "ADD SCHEDULE"}
          </h5>
          <Button close onClick={closeModal} />
        </div>
        <Row className="mt-2">
          <Col md={12}>
            <FormGroup>
              <Label className="fw-semibold">User *</Label>
              <Input
                type="select"
                value={driverInfo.user}
                invalid={!!errors.user}
                onChange={(e) => handleDriverInfoChange("user", e.target.value)}
              >
                <option value="">Select</option>
                <option value="0-1 Years">0-1 Years</option>
                <option value="1-3 Years">1-3 Years</option>
                <option value="3-5 Years">3-5 Years</option>
                <option value="5+ Years">5+ Years</option>
              </Input>
              <FormFeedback>{errors.user}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        {/* note */}
        <Row className="mt-2">
          <Col md={12}>
            <FormGroup>
              <Label className="fw-semibold">Date *</Label>
              <Input
                type="date"
                value={driverInfo.date}
                invalid={!!errors.date}
                onChange={(e) => handleDriverInfoChange("date", e.target.value)}
              />
              <FormFeedback>{errors.date}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col md={12}>
            <FormGroup>
              <Label className="fw-semibold">Note *</Label>
              <Input
                type="text"
                value={driverInfo.note}
                invalid={!!errors.note}
                onChange={(e) => handleDriverInfoChange("note", e.target.value)}
              />
              <FormFeedback>{errors.note}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>

        {/* Actions */}
        <div className="text-end mt-4">
          <Button color="primary" onClick={handleSubmit}>
            {editableData ? "Update" : "Save"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InprogressAddEditModal;
